import { SLOTS_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

export interface IBookingDetails {
  booking_id: string;
  booking_status: string;
  is_adjusted: boolean;
  is_charged: boolean;
  is_paid?: boolean;
  payment_status?: string;
  payment_link?: string;
  is_refundable?: boolean;
  amount?: string;
}
export interface IBookingDetailsResponse {
  massage: string;
  status: boolean;
  data: IBookingDetails | null;
}

type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useIsBookingChargableAPI = () => {
  const [bookingDetails, setBookingDetails] = useState<IBookingDetails | null>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const execute = useCallback(
    async (booking_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: InventoryTaxCreateAPIResponse = await axios
          .get(`${SLOTS_APIS?.IS_RESCHEDULE_PAID_ORNOT?.baseURL}`, {
            params: {
              booking_id: booking_id,
            },
            headers: {
              Authorization: `${accessToken}`,
            },
          })
          .then((res: AxiosResponse<IBookingDetailsResponse>) => {
            if (res.data.status === true && res.data) {
              setBookingDetails(res.data.data);
              return { status: true, message: "batch" };
            } else {
              setBookingDetails(null);
              return { status: false, message: "batch_not_created" };
            }
          })
          .catch((e: AxiosError) => {
            setBookingDetails(null);

            if (e.code === "ERR_BAD_REQUEST") {
              return { status: false, message: "batch_not_created" };
            }
            if (e.status === 400) {
              return { status: false, message: "batch_not_created" };
            }
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { bookingDetails, execute };
};
